import React from 'react';
import './Styles/Panel.scss';

const Panel=(props)=>{
    return(
        <div className="signup-panel">
            <p>"{props.feedback}"</p>
            <div className="profile">
                <div>
                    <img src={props.profile} />
                </div>
                <div>
                    <h4>{props.name}</h4>
                    <h5>{props.job}</h5>
                </div>
            </div>
        </div>
    )
};
export default Panel ;